export enum Key {
  Tab = 'Tab'
}


const FOCUSABLE_ELEMENTS_SELECTOR = [
  'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
  'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])', 'textarea:not([id=g-recaptcha-response])',
].join(', ');


export function getFocusableBoundaryElements(element: Element): HTMLElement[] {
  const list: HTMLElement[] =
    Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR) as NodeListOf<HTMLElement>)
      .filter(el => el.tabIndex !== -1);

  return [list[0], list[list.length - 1]];
}

// START GENAI@CHATGPT4
export function focusTrap(elementQuerySelector: string, stopFocusTrap:boolean) {
  let lastFocusedElement: EventTarget | null = null;
  const modalElement = document?.querySelector(elementQuerySelector);

  if(stopFocusTrap) {
    modalElement?.removeEventListener('focusin', () => {});
    modalElement?.removeEventListener('keydown', () => {});
    return;
  }

  modalElement?.addEventListener('focusin', (e: FocusEvent) => {
    lastFocusedElement = e.target;
  });

  modalElement?.addEventListener('keydown', async (e: KeyboardEvent) => {
    if (e.key === Key.Tab) {
      const [first, last] = getFocusableBoundaryElements(modalElement);

      if ((lastFocusedElement === first || lastFocusedElement === modalElement) && e.shiftKey) {
        last.focus();
        e.preventDefault();
      }

      if (lastFocusedElement === last && !e.shiftKey) {
        first.focus();
        e.preventDefault();
      }
    }
  });
}
// END GENAI@CHATGPT4
